import React, { useState } from 'react'

import { FieldArray } from 'formik'

import useSingleton from '../../../business-components/useSingleton/useSingleton'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import { 
    IsXsDownScreen
} from '../../../business-components/Service/GlobalService'

import {
    CLASSNAME
} from '../../../business-const/Style/Style'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    GridContainer,
    GridContainerGridItemButtonIncluirLinha,
    GridItem1xs2,
    GridItem2,
    GridItem2xs6,
    GridItem2xs12,
    GridItem2xs6NotIsXsDownScreen,
    GridItem5,
    GridItem4xs10,
    GridItem4xs12,
    GridItem6,
    GridItem6xs12,
    GridItem7,
    GridItem7xs10,
    GridItem7xs10NotIsXsDownScreen,
    GridItem10,
    GridItem12,
    GridItem12mt12IsXsDownScreen,
} from '../../../business-components/Grid/Grid'

import {
    CardGridDividerElementos,
} from '../../../business-components/Card/Card'

import {
    TextFieldNumberSelect,
} from '../../../business-components/TextField/TextFieldSelect'

import {
    pesquisaList
} from '../../../business-rules/List/ListService'

import familiaresList from '../../../business-rules/List/familiaresList'

import tipoReceitaMensalList from '../../../business-rules/List/tipoReceitaMensalList'

import tipoMultiploSalarioSeguroVidaEmGrupo from '../../../business-rules/List/tipoMultiploSalarioSeguroVidaEmGrupo'

import {
    IconButtonMaisInformacoes,
} from '../../../business-components/IconButton/IconButton'

import {
    ButtonIncluirLinha
} from '../../../business-components/Button/Button'

import {
    CustomizedDialogsPopup,
} from '../../../business-components/Dialog/CustomizeDialogs'

import {
    obtemPage,
    salvaPage,
} from '../cliente-form/ClienteService'

import {
    TablePaginationPadraoReceitaMensal,
    rowPertentePageReceitaMensal,
    setPageInclusaoReceitaMensal,
    Familiar,
    IconButtonClearEntradaDadosReceitaMensal,
    TipoReceitaMensal,
    ValorBruto,
    Valor,
    TipoPeriodicidadeRecebto,
    ValorInssPensaoInvalidez,
    PeriodoReceitaMensal,
    AlterarTipoCalculoAcumulado,
    MesAnoInicial,
    MesAnoFinal,
    ReceitaMensalAteAposentadoria,
    DescricaoOutras,
} from '../garantias-form/GarantiasCompReceitaMensal'

import {
    incrementaContReceitaMensal,
    processaRegistrosDefaultIniciaisReceitaMensal,
    processaValoresDefaultIniciaisReceitaMensal,
    calculaTotaisReceitaMensal,
} from '../garantias-form/GarantiasServiceReceitaMensal'

import {
    processaFormRegistrosDefaultIniciaisSortAscFamiliar
} from './FormService'

import GarantiasFormReceitaMensalItem from '../garantias-form/GarantiasFormReceitaMensalItem'


const ExpandirExcluir = ({ values, handleChange, setFieldValue, title, arrayHelpers, item, ind, tipoReceitaMensalSelecionada,
    tipoMultiploSalarioSeguroVidaEmGrupoSelecionado, setExpandiu }) => {

    return (
        <GridContainer>
            {(tipoReceitaMensalSelecionada.informaValorBruto === "S" ||
            tipoReceitaMensalSelecionada.informaInssPensao === "I" ||
            tipoReceitaMensalSelecionada.informaInssPensao === "P"
            ) && (
                <GridItem12mt12IsXsDownScreen/>
            )}
            <GridItem6
                className="mt-2"
            >
                <CustomizedDialogsPopup
                    maxWidth="sm"
                    popupTitle={title}
                    tooltipTitle={LABEL.expandir}
                    PopupButton={IconButtonMaisInformacoes}
                    popupButtonDestaque={false}
                    DialogContentClassName={CLASSNAME().dialogContentClassNameFormExpandir}
                    popupComponent={
                        <GarantiasFormReceitaMensalItem
                            values={values}
                            handleChange={handleChange}
                            setFieldValue={setFieldValue}
                            arrayHelpers={arrayHelpers}
                            tipoReceitaMensalSelecionada={
                                tipoReceitaMensalSelecionada
                            }
                            tipoMultiploSalarioSeguroVidaEmGrupoSelecionado={
                                tipoMultiploSalarioSeguroVidaEmGrupoSelecionado
                            }
                            item={item}
                            ind={ind}
                            simplificado={true}
                        />
                    }
                    open={setExpandiu}
                    afterClose={setExpandiu}
                />
            </GridItem6>
            <GridItem6
                className="mt-2"
            >
                <IconButtonClearEntradaDadosReceitaMensal
                    values={values}
                    setFieldValue={setFieldValue}
                    item={item}
                    ind={ind}
                    arrayHelpers={arrayHelpers}
                />
            </GridItem6>
        </GridContainer>
    )
}
const FormFormReceitaMensal = ({ values, handleChange, setFieldValue, title }) => {
    
    const [expandiu, setExpandiu] = useState(false)
    
    calculaTotaisReceitaMensal(values)
    
    useSingleton(async () => {

        processaFormRegistrosDefaultIniciaisSortAscFamiliar(values, values.totalReceitaMensal, processaRegistrosDefaultIniciaisReceitaMensal,
            values.receitaMensal)

        values.pageReceitaMensal = obtemPage(values.pageReceitaMensalList, HARDCODE.idFamiliarPage)
    })

    values.processarIncluiRecursosFinanceirosFGTSContribuicaoReceitaMensalCLT = true

    values.processarIncluiSeguroVidaSeguroVidaEmGrupo = true

    salvaPage(values.pageReceitaMensal, values.pageReceitaMensalList, HARDCODE.idFamiliarPage)
    
    let indAux = 0

    values.receitaMensalPagination =
        values.receitaMensal
            ?
                values.receitaMensal.filter(item => !item.idReceitaMensal && !item.idPatrimonioImobilizado)
            :
                []

    const isXsDownScreen = IsXsDownScreen()



    return (
        <FieldArray name="receitaMensal">
            {(arrayHelpers) => (
                <DivForm>
                    <GridContainer>
                        {values.receitaMensal?.map((item, ind) => {
                            
                            if (!item.idReceitaMensal && !item.idPatrimonioImobilizado && rowPertentePageReceitaMensal(values, indAux++)) {

                                let tipoReceitaMensalSelecionada = pesquisaList(tipoReceitaMensalList, 
                                    item.tipoReceitaMensal)

                                processaValoresDefaultIniciaisReceitaMensal(values, item, ind, tipoReceitaMensalSelecionada)

                                let tipoMultiploSalarioSeguroVidaEmGrupoSelecionado =
                                    pesquisaList(tipoMultiploSalarioSeguroVidaEmGrupo,
                                        item.tipoMultiploSalarioSeguroVidaEmGrupo)

                                return (
                                    <GridItem12
                                        key={ind}
                                    >
                                        <GridContainer>
                                            <GridItem4xs10>
                                                <GridContainer>
                                                    <GridItem5>
                                                        <Familiar
                                                            values={values}
                                                            item={item}
                                                            ind={ind}
                                                            handleChange={handleChange}
                                                            expandiu={expandiu}
                                                        />
                                                    </GridItem5>
                                                    
                                                    <GridItem7>
                                                        <TipoReceitaMensal
                                                            TextFieldNumberSelectTipoReceitaMensal={
                                                                TextFieldNumberSelect
                                                            }
                                                            values={values}
                                                            item={item}
                                                            ind={ind}
                                                            handleChange={handleChange}
                                                            expandiu={expandiu}
                                                        />
                                                    </GridItem7>
                                                </GridContainer>
                                            </GridItem4xs10>

                                            {item.tipoReceitaMensal
                                                ?
                                                    <GridItem7xs10>
                                                        <GridContainer>
                                                            {tipoReceitaMensalSelecionada.informaValorBruto === "S"
                                                                ?
                                                                    <GridItem2xs6>
                                                                        <ValorBruto
                                                                            item={item}
                                                                            ind={ind}
                                                                            handleChange={handleChange}
                                                                            expandiu={expandiu}
                                                                        />
                                                                    </GridItem2xs6>
                                                                :
                                                                    <GridItem2xs6NotIsXsDownScreen/>
                                                            }
                                                            <GridItem2xs6>
                                                                <Valor
                                                                    values={values}
                                                                    item={item}
                                                                    ind={ind}
                                                                    handleChange={handleChange}
                                                                    //tipoReceitaMensalSelecionada={tipoReceitaMensalSelecionada}
                                                                    expandiu={expandiu}
                                                                />
                                                            </GridItem2xs6>
                                                            <GridItem2xs6>
                                                                <TipoPeriodicidadeRecebto
                                                                    item={item}
                                                                    ind={ind}
                                                                    handleChange={handleChange}
                                                                    expandiu={expandiu}
                                                                />
                                                            </GridItem2xs6>
                                                            
                                                            <GridItem2xs6>
                                                                {(
                                                                    tipoReceitaMensalSelecionada.informaInssPensao === "I" ||
                                                                    tipoReceitaMensalSelecionada.informaInssPensao === "P"
                                                                )    && (
                                                                    <ValorInssPensaoInvalidez
                                                                        item={item}
                                                                        ind={ind}
                                                                        handleChange={handleChange}
                                                                        tipoReceitaMensalSelecionada={tipoReceitaMensalSelecionada}
                                                                        simplificado={true}
                                                                    />
                                                                )}
                                                            </GridItem2xs6>

                                                            <GridItem4xs12>
                                                                <DescricaoOutras
                                                                    item={item}
                                                                    ind={ind}
                                                                    handleChange={handleChange} 
                                                                    expandiu={expandiu}
                                                                />
                                                            </GridItem4xs12>
                                                        </GridContainer>
                                                    </GridItem7xs10>
                                                :
                                                    <GridItem7xs10NotIsXsDownScreen />
                                            }

                                            {!isXsDownScreen && (
                                                <GridItem1xs2>
                                                    <ExpandirExcluir
                                                        values={values}
                                                        handleChange={handleChange}
                                                        setFieldValue={setFieldValue}
                                                        title={title}
                                                        arrayHelpers={arrayHelpers}
                                                        item={item}
                                                        ind={ind}
                                                        tipoReceitaMensalSelecionada={tipoReceitaMensalSelecionada}
                                                        tipoMultiploSalarioSeguroVidaEmGrupoSelecionado={
                                                            tipoMultiploSalarioSeguroVidaEmGrupoSelecionado
                                                        }
                                                        setExpandiu={setExpandiu}
                                                    />
                                                </GridItem1xs2>
                                            )}
                                        </GridContainer>

                                        {item.tipoReceitaMensal && (
                                            <>
                                                <GridContainer>
                                                    {!isXsDownScreen && (
                                                        <GridItem4xs10/>
                                                    )}

                                                    <GridItem7xs10>
                                                        <GridContainer>
                                                            {!isXsDownScreen && (
                                                                <GridItem2xs12/>
                                                            )}

                                                            <GridItem2xs12
                                                                className={isXsDownScreen ? '' : 'mt-2'}
                                                            >
                                                                {!expandiu &&
                                                                tipoReceitaMensalSelecionada.permiteAlterarTipoCalculoAcumulado === 'S' &&
                                                                item.tipoPeriodicidadeRecebto !== HARDCODE.idTipoPeriodicidadeUnica && (
                                                                    <AlterarTipoCalculoAcumulado
                                                                        values={values}
                                                                        item={item}
                                                                        ind={ind}
                                                                        handleChange={handleChange}
                                                                        tipoReceitaMensalSelecionada={tipoReceitaMensalSelecionada}
                                                                    />
                                                                )}
                                                            </GridItem2xs12>

                                                            {item.alterarTipoCalculoAcumulado
                                                                ?
                                                                    <>
                                                                        <GridItem4xs12>
                                                                            <GridContainer>
                                                                                <GridItem6>
                                                                                    <MesAnoInicial
                                                                                        item={item}
                                                                                        ind={ind}
                                                                                        handleChange={handleChange}
                                                                                        expandiu={expandiu}
                                                                                    />
                                                                                </GridItem6>
                                                                                <GridItem6>
                                                                                    {!item.receitaMensalAteAposentadoria &&
                                                                                    item.tipoPeriodicidadeRecebto !== HARDCODE.idTipoPeriodicidadeUnica && (
                                                                                        <MesAnoFinal
                                                                                            item={item}
                                                                                            ind={ind}
                                                                                            handleChange={handleChange}
                                                                                            expandiu={expandiu}
                                                                                        />
                                                                                    )}
                                                                                </GridItem6>
                                                                            </GridContainer>
                                                                        </GridItem4xs12>
                                                                        <GridItem4xs12
                                                                            className={isXsDownScreen ? '' : 'mt-2'}
                                                                        >
                                                                            {!expandiu &&
                                                                            item.tipoPeriodicidadeRecebto !== HARDCODE.idTipoPeriodicidadeUnica && (
                                                                                <ReceitaMensalAteAposentadoria
                                                                                    item={item}
                                                                                    ind={ind}
                                                                                    handleChange={handleChange}
                                                                                />
                                                                            )}
                                                                        </GridItem4xs12>
                                                                    </>
                                                                :
                                                                    <GridItem6xs12
                                                                        className={isXsDownScreen ? '' : 'mt-5'}
                                                                    >
                                                                        <PeriodoReceitaMensal
                                                                            tipoReceitaMensalSelecionada={
                                                                                tipoReceitaMensalSelecionada
                                                                            }
                                                                        />
                                                                    </GridItem6xs12>
                                                            }
                                                        </GridContainer>
                                                    </GridItem7xs10>
                                                </GridContainer>

                                                {isXsDownScreen && (
                                                    <GridContainer>
                                                        <GridItem10/>
                                                        
                                                        <GridItem2
                                                            className={
                                                                item.alterarTipoCalculoAcumulado
                                                                    ?
                                                                        'mt--29'
                                                                    :
                                                                        tipoReceitaMensalSelecionada.tipoCalculoAcumulado !== "VT"
                                                                            ?
                                                                                tipoReceitaMensalSelecionada.tipoCalculoAcumulado === "AA" ||
                                                                                tipoReceitaMensalSelecionada.tipoCalculoAcumulado === "PA"
                                                                                    ?
                                                                                        'mt--25'
                                                                                    :
                                                                                        'mt--30'

                                                                            :
                                                                                'mt--11'
                                                            }
                                                        >
                                                            <ExpandirExcluir
                                                                values={values}
                                                                handleChange={handleChange}
                                                                setFieldValue={setFieldValue}
                                                                title={title}
                                                                arrayHelpers={arrayHelpers}
                                                                item={item}
                                                                ind={ind}
                                                                tipoReceitaMensalSelecionada={tipoReceitaMensalSelecionada}
                                                                tipoMultiploSalarioSeguroVidaEmGrupoSelecionado={
                                                                    tipoMultiploSalarioSeguroVidaEmGrupoSelecionado
                                                                }
                                                                setExpandiu={setExpandiu}
                                                            />
                                                        </GridItem2>
                                                    </GridContainer>
                                                )}
                                            </>
                                        )}
                                        
                                        {isXsDownScreen && values.receitaMensalPagination.length - 1 !== ind && (
                                            <CardGridDividerElementos />
                                        )}
                                    </GridItem12>
                                )
                                
                            } else {

                                return ''
                            }
                        })}
                    </GridContainer>

                    <TablePaginationPadraoReceitaMensal
                        values={values}
                        setFieldValue={setFieldValue}
                    />
                    
                    <GridContainerGridItemButtonIncluirLinha>
                        <ButtonIncluirLinha
                            label={LABEL.buttonIncluirReceitaMensal} 
                            align='right'
                            disabled={familiaresList(values).length === 0 ? true : false}
                            onClick={() => 
                                {
                                    incrementaContReceitaMensal(values)
                                    arrayHelpers.push({
                                        id: values.contReceitaMensal,
                                        familiar: HARDCODE.idFamiliarCliente,
                                    })
                                    setPageInclusaoReceitaMensal(values, setFieldValue)
                                }
                            }
                        />
                    </GridContainerGridItemButtonIncluirLinha>
                </DivForm>
            )}
        </FieldArray>
    )
}

export default FormFormReceitaMensal